import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/error.js")